import React, { Component } from 'react'
import { withRouter } from "react-router-dom";
import PropTypes from 'prop-types'
import { Box } from 'grommet/components/Box';
import { Text } from 'grommet/components/Text';
import { Button } from 'grommet/components/Button';
import { Anchor } from 'grommet/components/Anchor';
import { TextInput } from 'grommet/components/TextInput';
import AccessibleSelect from './AccessibleSelect';
import { Layer } from 'grommet/components/Layer';
import ReactTable from "react-table";
/*import Pagination from './../Components/Pagination';
import data from '../Data.json';*/
import { ERRORMESSAGE } from '../Constants.js';
import { POPUPEMAIL, DISPUTE } from '../Constants.js';
import { SearchPointOfSalesCtrl } from "../Controllers/Transaction/SearchPointOfSalesCtrl";
import { AddMultipleAdminCtrl } from "../Controllers/Ebox/AddMultipleAdmin";
import ModalErrorTimeout from './ModalErrorTimeout';
/*import { SearchUserListCtrl } from '../Controllers/Ebox/SearchUserListCtrl';*/
import { logout } from '../Utils/Utility';


class DatiGestore extends Component {
    static propTypes = {
        match: PropTypes.object.isRequired,
        location: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired
    }
    constructor(props) {
        super(props);
        this.state = {
            data: this.props.values.tablePointofSales,
            optionsList: [],
            disableBtn: true,
            listUsername: [],
            listPV: this.props.values.codes,
            currentPage: this.props.values.currentPage,
            pages: this.props.values.pages,
            finalList: [],
            usernamePV: [],
            optionPV: [],
            showTimeoutModal: false,
            mapGestoreUser: this.props.values.mapGestoreUser !== undefined ? this.props.values.mapGestoreUser : new Map(),
        }
        this.renderEditable = this.renderEditable.bind(this);
        this.changePvGestore = this.changePvGestore.bind(this);
        this.readListUsername = this.readListUsername.bind(this);
        this.getPointOfSales = this.getPointOfSales.bind(this);
        this.resetPage = this.resetPage.bind(this);
        this.redirectRegistration = this.redirectRegistration.bind(this);
    }
    componentWillReceiveProps(nextProps) {
        if (nextProps.values.listUsername && JSON.stringify(nextProps.values.listUsername) !== JSON.stringify(this.state.listUsername)) {
            this.setState({ listUsername: Array.isArray(nextProps.values.listUsername) ? nextProps.values.listUsername : [] })
        }
    }

    componentWillMount() {
        const initialObj = [
            {
                page: 1,
                data: this.state.data
            }
        ];

        let list = [];
        if (Array.isArray(this.state.listPV) && this.state.listPV.length > 0) {
            list = this.state.listPV.map((el) => (el && el.pos !== null ? el.pos : []))
        }

        this.setState({
            finalList: initialObj,
            optionPV: list
        });
    }

    updateGestore(){
        let data= this.state.data;
        let map = this.state.mapGestoreUser;
        let optionPV = this.state.optionPV;
        let i;
        for(i=0;i<data.length;i++){
            let index = map.get(data[i].code) !== undefined && optionPV.indexOf(map.get(data[i].code)["codGestore"]) !== undefined ? optionPV.indexOf(map.get(data[i].code)["codGestore"]) : -1;
            let user = map.get(data[i].code) !== undefined && map.get(data[i].code)["username"] !== undefined ? map.get(data[i].code)["username"] : '';
            let email = map.get(data[i].code) !== undefined && map.get(data[i].code)["email"] !== undefined ? map.get(data[i].code)["email"] : '';
            if(index !== -1){
                this.editPvGestore(i, map.get(data[i].code)["codGestore"], index, user, email);
            }
        }
    }

    componentDidMount() {
        this.updateGestore();
    }

    saveAndContinue = (e, id) => {
        if (id === 'gestori') {
            let finalArray = [];
            let i, j;
            let obj = {};
            for (i = 0; i < this.state.finalList.length; i++) {
                for (j = 0; j < this.state.finalList[i].data.length; j++) {
                    obj = {
                        codPos: this.state.finalList[i].data[j].code,
                        signboard: this.state.finalList[i].data[j].name,
                        city: this.state.finalList[i].data[j].city,
                        codAdmin: this.state.finalList[i].data[j].gest,
                        email: this.state.finalList[i].data[j].email,
                        user: this.state.finalList[i].data[j].userName
                    };
                    finalArray.push(obj);
                }
            }

            var token = sessionStorage.getItem('token')
            var ids = sessionStorage.getItem('ids')
            const self = this;
            AddMultipleAdminCtrl(function (data) {
                self.props.history.push({
                    data: data
                });

                //e.preventDefault();
                self.props.nextStep();

            }, function (error) {
                self.setState({
                    status: error
                }, function () {
                    if (self.state.status === 500 || self.state.status === 400 || self.state.status === 404 || self.state.status === 403) {
                        self.props.history.push({
                            pathname: '/ErrorPage',
                            state: this.state
                        })
                    } else if (self.state.status === 401) {
                        this.setState({
                            showTimeoutModal: true
                        })
                        // logout();
                        // self.props.history.push({
                        //     pathname: '/login'
                        // })
                    }
                })
            }, token, ids, finalArray);

        } else {
            this.props.history.push({
                gestPage: 3
            });
            e.preventDefault();
            this.props.nextStep();
        }
    }

    changePvGestore(row, e) {
        let data = this.state.data;
        let selected = e.selected;

        let usernamePV = [];
        if (this.state.listPV[selected] !== undefined || this.state.listPV[selected].userName !== undefined) {
            usernamePV = this.state.listPV[selected].userName.map((el) => (el.userName === undefined ? [] : el.userName));
            if (usernamePV.length > 1) {
                usernamePV.unshift("Tutti");
            }
        }
        data[row.index].gest = e.value;
        data[row.index].usernamePV = usernamePV;
        data[row.index].userName = '';

        this.setState({
            data: data
        }, this.validateContents());
    }

    editPvGestore(index, gestore, posGest, user, email) {
        let data = this.state.data;
        let selected = posGest;

        let usernamePV = [];
        if (this.state.listPV[selected] !== undefined || this.state.listPV[selected].userName !== undefined) {
            usernamePV = this.state.listPV[selected].userName.map((el) => (el.userName === undefined ? [] : el.userName));
            if (usernamePV.length > 1) {
                usernamePV.unshift("Tutti");
            }
        }
        data[index].gest = gestore;
        data[index].usernamePV = usernamePV;
        data[index].userName = user;
        data[index].email = email
        data[index].errorMail = ''

        this.setState({
            data: data
        }, this.validateContents());
    }

    changePvUser(row, e) {
        var data = this.state.data;
        data[row.index].userName = e.value;
        this.setState({
            data: data
        }, this.validateContents());
    }

    validateContents() {
        var i = 0;
        var gestEmpty = false;
        var emailEmpty = false;
        var userEmpty = false;
        var data = this.state.data;
        let finalList = this.state.finalList;
        let cp = this.state.currentPage;

        while (i < data.length && !gestEmpty) {
            if (data[i].gest === '' || data[i].gest === undefined) {
                gestEmpty = true;
            }
            i++;
        }

        i = 0;
        while (i < data.length && !userEmpty) {
            if (data[i].userName === '' || data[i].userName === undefined) {
                userEmpty = true;
            }
            i++;
        }

        i = 0;
        while (i < data.length && !emailEmpty) {
            if (data[i].email === '' || data[i].email === undefined || data[i].errorMail !== '' || data[i].errorMail === undefined) {
                emailEmpty = true;
            }
            i++;
        }
        if (!gestEmpty && !emailEmpty && !userEmpty) {
            finalList[cp - 1].valid = true;
            this.setState({
                finalList: finalList
            }, () => { this.activateButton() })
        } else {
            finalList[cp - 1].valid = false;
            this.setState({
                finalList: finalList
            }, () => { this.activateButton() })
        }
    }

    activateButton() {
        let i = 0;
        let validPage = true;
        let numPage = this.state.pages;
        let finalList = this.state.finalList;
        i = 0;
        while (i < numPage && validPage) {
            if (finalList[i] === undefined || finalList[i].valid === undefined || !finalList[i].valid) {
                validPage = false;
            }
            i++;
        }
        if (!validPage) {
            this.setState({
                disableBtn: true
            })
        } else {
            this.setState({
                disableBtn: false
            })
        }
    }

    back = (e) => {
        e.preventDefault();
        this.props.prevStep();
    }

    prevPage() {
        let cp = this.state.currentPage;
        let finalList = this.state.finalList;

        if (cp === 1) return;

        let listPage = {
            page: cp,
            data: this.state.data,
            valid: finalList[cp - 1].valid === undefined ? false : finalList[cp - 1].valid
        };

        finalList[cp - 1] = listPage;

        this.setState({
            currentPage: cp - 1,
            finalList: finalList
        }, () => {
            this.getPointOfSales();
        });
    }

    nextPage() {
        let cp = this.state.currentPage;
        let finalList = this.state.finalList;
        if (cp === this.state.pages) return;

        let listPage = {
            page: cp,
            data: this.state.data,
            valid: finalList[cp - 1].valid === undefined ? false : finalList[cp - 1].valid
        };

        finalList[cp - 1] = listPage;

        this.setState({
            currentPage: cp + 1,
            finalList: finalList
        }, () => {
            this.getPointOfSales();
        });
    }

    getPointOfSales() {
        let finalList = this.state.finalList;
        let currentPage = this.state.currentPage;
        if (finalList[currentPage - 1] === undefined || finalList[currentPage - 1].data === undefined) {
            var token = sessionStorage.getItem('token')
            var ids = sessionStorage.getItem('ids')
            const self = this;
            SearchPointOfSalesCtrl(function (data, pages, currentPage) {
                let listPage = {
                    page: currentPage,
                    data: data
                };
                finalList[currentPage - 1] = listPage;

                self.setState({
                    data: data === undefined ? [] : data,
                    pages: pages === undefined ? 0 : pages,
                    finalList: finalList
                },()=>self.updateGestore());
            }, function (error) {
                self.setState({
                    status: error
                }, function () {
                    if (this.state.status === 500 || this.state.status === 400 || this.state.status === 404 || this.state.status === 403) {
                        this.props.history.push({
                            pathname: '/ErrorPage',
                            state: this.state
                        })
                    } else if (this.state.status === 401) {
                        this.setState({
                            showTimeoutModal: true
                        })
                        // logout();
                        // this.props.history.push({
                        //     pathname: '/login'
                        // })
                    }
                })

            }, token, ids, this.state.currentPage, '');
        } else {
            this.setState({
                data: finalList[currentPage - 1].data
            });
        }
    }

    renderEditable(row) {

        return ([
            <input type='email'
                style={{ width: '120px', height: '25px', fontSize: '12px', color: '#006FCF', borderRadius: '4px', border: '1px solid rgba(0,0,0,0.33)', padding: '3px 10px' }}
                value={this.state.data[row.index].email !== undefined ? this.state.data[row.index].email : ''}
                contentEditable
                suppressContentEditableWarning
                onChange={e => {
                    const data = [...this.state.data];
                    //const emailreg = /^([a-zA-Z0-9_\.-]+)@([\da-zA-Z\.-]+)\.([a-zA-Z\.]{2,6})$/;
                    const emailreg = /^([a-zA-Z0-9_.-]+)@([\da-zA-Z.-]+)\.([a-zA-Z.]{2,6})$/;
                    data[row.index].email = e.target.value;
                    data[row.index].errorMail = emailreg.test(e.target.value) ? '' : 'Email non valida';
                    this.setState({ data: data }, this.validateContents());
                }}

            />,
            <div style={{ color: "E1242B", fontSize: '12px' }}>{this.state.data[row.index].errorMail}</div>

        ]);
    }
    /*
    readListUsername() {
        let list = [];
        if (this.state.listBySoc !== [] || this.state.listBySoc !== null) {
            list = this.state.listBySoc.userName.map((el) => (el.userName === null ? [] : el.userName))
        }
        return list;
    }*/


    readListUsername() {
        let listUtenti = this.state.listUsername.map((el) => el.userName);

        var first = "Tutti";
        listUtenti.sort(function(x,y){ return x === first ? -1 : y === first ? 1 : 0; }); 
        console.log(listUtenti);
        // if (listUtenti.length > 1){
        //     listUtenti.unshift("Tutti");
        // }
        return listUtenti;
        
    }

    resetPage() {
        this.setState({
            currentPage: 1
        })
    }

    redirectRegistration() {
        logout();
    }


    render() {

        const sendEmail = (<Layer
            flush={true}
            margin='medium'
            onClickOutside={this.props.closeModalGestore}
            onEsc={this.props.closeModalGestore}>
            <Box overflow='auto'>

                <Text className='titlehome titleModal'>
                    {POPUPEMAIL.title}
                    <button type="button" aria-label="Chiudi finestra" title="Chiudi" style={{ background: 'none', border: 'none', padding: 0, margin: 0, float: 'right', cursor: 'pointer' }} onClick={this.props.closeModalGestore}>
  <i className='icon-close' aria-hidden="true" style={{ textAlign: 'right', fontSize: '15px', color: '#000000' }} />
</button>
                </Text>
                <Text className='subtitlehome subtitleModal' style={{ marginTop: '0' }}>
                    {POPUPEMAIL.text1}
                </Text>
                <Text className='subtitlehome textModal' style={{ marginTop: '10px' }}>
                    {POPUPEMAIL.text2}
                    <br></br>
                    {POPUPEMAIL.text3}
                    <br></br>
                    {POPUPEMAIL.text4}
                </Text>
            </Box>
        </Layer>

        )

        const columns = [
            {
                Header: 'CODICE ESERCIZIO',
                accessor: 'code',
                headerClassName: 'sH',
                style: {
                    fontSize: '10px'
                }
            },
            {
                Header: 'DESCRIZIONE',
                accessor: 'name',
                headerClassName: 'sH',
                style: {
                    fontSize: '10px'
                }
            },
            {
                Header: 'INDIRIZZO',
                accessor: 'address',
                headerClassName: 'sH',
                style: {
                    fontSize: '10px'
                }

            },
            {
                Header: 'CITTÀ',
                accessor: 'city',
                headerClassName: 'sH',
                style: {
                    fontSize: '10px'
                }

            }
        ]

        const tableGestori = [
            {
                id: 'Address',
                Header: 'CODICE PUNTO VENDITA - INSEGNA - CITTÀ',
                accessor: props => props.code + "-" + props.name + "-" + props.city,
                headerClassName: 'sH',
                width: 150,
                style: {
                    fontSize: '10px'
                }
            },
            {
                Header: 'CODICE PUNTO VENDITA DEL GESTORE',
                accessor: 'selectedCode',
                headerClassName: 'sH',
                width: 150,
                className: 'selectTable',
                Cell: (row) => <AccessibleSelect id={'selectionCode' + [row.index]} style={{ width: '120px', height: '25px' }}
                    options={this.state.optionPV} value={this.state.data[row.index].gest} onChange={e => this.changePvGestore(row, e)} />
            },
            {
                Header: 'USERNAME PV ISCRITTO',
                accessor: 'indirizzo',
                headerClassName: 'sH',
                width: 150,
                className: 'selectTable',
                Cell: (row) => <AccessibleSelect id={'selectionUser' + [row.index]} style={{ width: '120px', height: '25px' }} options={this.state.data[row.index].usernamePV !== undefined ? this.state.data[row.index].usernamePV : []} value={this.state.data[row.index].userName !== undefined ? this.state.data[row.index].userName : ''} onChange={e => this.changePvUser(row, e)} />
            },
            {
                Header: 'EMAIL DEL GESTORE',
                accessor: 'email',
                headerClassName: 'sH',
                width: 150,
                className: 'selectTable',
                Cell: this.renderEditable
            }
        ]

        const pointofsale = (<Layer
            flush={true}
            margin='medium'
            onClickOutside={() => { this.props.closeModalGestore(); this.resetPage(); }}
            onEsc={() => { this.props.closeModalGestore(); this.resetPage(); }}>
            <Box overflow='auto' style={{ padding: '50px 50px 0', minWidth: '800px' }}>
                <button type="button" aria-label="Chiudi finestra" title="Chiudi" style={{ background: 'none', border: 'none', padding: 0, margin: 0, float: 'right', cursor: 'pointer', position: 'relative', bottom: '10px' }} onClick={() => { this.props.closeModalGestore(); this.resetPage(); }}>
  <i className='icon-close' aria-hidden="true" style={{ textAlign: 'right', fontSize: '15px', color: '#000000' }} />
</button>
                <ReactTable
                    data={this.state.data}
                    columns={columns}
                    sortable={true}
                    multiSort={true}
                    resizable={false}
                    showPagination={false}
                    loading={false}
                    defaultPageSize={10}
                    style={{ paddingBottom: '20px' }}
                />
                <div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px', height: '50px' }}>
                        <button
                            type="button"
                            style={{ width: '20px', background: 'none', border: 'none', padding: 0, color: this.state.currentPage === 1 ? '#999' : '#006fcf', cursor: this.state.currentPage === 1 ? 'not-allowed' : 'pointer', display: 'inline-flex', alignItems: 'center' }}
                            onClick={(e) => { e.preventDefault(); if (this.state.currentPage > 1) this.goToPage(1); }}
                            onKeyDown={(e) => { if ((e.key === 'Enter' || e.key === ' ') && this.state.currentPage > 1) { e.preventDefault(); this.goToPage(1); } }}
                            tabIndex={this.state.currentPage === 1 ? "-1" : "0"}
                            aria-label="Vai alla prima pagina"
                            aria-disabled={this.state.currentPage === 1}>
                            <i className='icon-double-left' style={{ fontSize: '12px', fontStyle: 'normal' }} aria-hidden="true"></i>
                        </button>
                        <button
                            type="button"
                            style={{ width: '20px', background: 'none', border: 'none', padding: 0, color: this.state.currentPage === 1 ? '#999' : '#006fcf', cursor: this.state.currentPage === 1 ? 'not-allowed' : 'pointer', display: 'inline-flex', alignItems: 'center' }}
                            onClick={(e) => { e.preventDefault(); if (this.state.currentPage > 1) this.prevPage(); }}
                            onKeyDown={(e) => { if ((e.key === 'Enter' || e.key === ' ') && this.state.currentPage > 1) { e.preventDefault(); this.prevPage(); } }}
                            tabIndex={this.state.currentPage === 1 ? "-1" : "0"}
                            aria-label="Pagina precedente"
                            aria-disabled={this.state.currentPage === 1}>
                            <i className='icon-left-chevron' style={{ fontSize: '12px', fontStyle: 'normal' }} aria-hidden="true"></i>
                        </button>

                        <Text className='pag' style={{ fontSize: '12px', marginBottom: '12px', whiteSpace: 'nowrap' }}>{this.state.currentPage} di {this.state.pages}</Text>

                        <button
                            type="button"
                            style={{ width: '20px', background: 'none', border: 'none', padding: 0, color: this.state.currentPage === this.state.pages ? '#999' : '#006fcf', cursor: this.state.currentPage === this.state.pages ? 'not-allowed' : 'pointer', display: 'inline-flex', alignItems: 'center' }}
                            onClick={(e) => { e.preventDefault(); if (this.state.currentPage < this.state.pages) this.nextPage(); }}
                            onKeyDown={(e) => { if ((e.key === 'Enter' || e.key === ' ') && this.state.currentPage < this.state.pages) { e.preventDefault(); this.nextPage(); } }}
                            tabIndex={this.state.currentPage === this.state.pages ? "-1" : "0"}
                            aria-label="Pagina successiva"
                            aria-disabled={this.state.currentPage === this.state.pages}>
                            <i className='icon-right-chevron' style={{ fontSize: '12px', fontStyle: 'normal' }} aria-hidden="true"></i>
                        </button>
                        <button
                            type="button"
                            style={{ width: '20px', background: 'none', border: 'none', padding: 0, color: this.state.currentPage === this.state.pages ? '#999' : '#006fcf', cursor: this.state.currentPage === this.state.pages ? 'not-allowed' : 'pointer', display: 'inline-flex', alignItems: 'center' }}
                            onClick={(e) => { e.preventDefault(); if (this.state.currentPage < this.state.pages) this.goToPage(this.state.pages); }}
                            onKeyDown={(e) => { if ((e.key === 'Enter' || e.key === ' ') && this.state.currentPage < this.state.pages) { e.preventDefault(); this.goToPage(this.state.pages); } }}
                            tabIndex={this.state.currentPage === this.state.pages ? "-1" : "0"}
                            aria-label="Vai all'ultima pagina"
                            aria-disabled={this.state.currentPage === this.state.pages}>
                            <i className='icon-double-right' style={{ fontSize: '12px', fontStyle: 'normal' }} aria-hidden="true"></i>
                        </button>
                    </div>
                </div>
            </Box>
        </Layer>

        )

        const enabled = this.props.values.msgemailGestore || this.props.values.emailGestore === '' || this.props.values.selectedUser === ''

        const optionsType = [
            "",
            "Società",
            "Punto Vendita"
        ]

        const Gestore = (<Box>
            {this.state.showTimeoutModal || this.props.values.showTimeoutModal ? <ModalErrorTimeout /> : ''}
            <Box style={{ padding: '30px 20px 0 20px' }}>
                <Text className='subtitlehome' style={{ marginBottom: '20px' }}><span className='bold'>Solo se il GESTORE è diverso dal RESPONSABILE</span>, indica nei campi di seguito il codice e l'indirizzo e-mail del Punto Vendita (GESTORE).</Text>
                <Text className='subtitlehome' style={{ marginBottom: '20px' }}>{DISPUTE.infoParagraph10} <Anchor onClick={this.props.showModalpointofsale}>clicca qui</Anchor>{this.props.values.openModalpoint === true ? pointofsale : ''}</Text>
                <Text className='subtitlehome'>{DISPUTE.infoParagraph11} <Anchor onClick={this.props.showGestori}>clicca qui</Anchor></Text>
            </Box>
            <Box style={{ padding: '30px 20px 0 20px' }}>
                <Text className='titleDispute'><h3>DEFINISCI GESTORE</h3></Text>
            </Box>
            <Box style={{ padding: '30px 50px 0 50px' }}>
                <Box align='center'>
                    {this.props.values.selectedType === "Punto Vendita" && this.props.values.codes.length === 0 ? <span style={{color: "#E1242B", height: "20px"}}>Non sono presenti punti vendita iscritti al portale</span> : <span style={{height: "20px"}}></span>}
                    <Box id='searchpv' style={{ marginBottom: '29px' }}>
                        <Text className='label' id='typegest-label' htmlFor='typegest' aria-hidden="false">TIPO GESTORE</Text>
                        <AccessibleSelect 
                            id='typegest' 
                            className='select' 
                            placeholder='' 
                            options={optionsType} 
                            value={this.props.values.selectedType} 
                            onChange={this.props.setSelectionType}
                            aria-labelledby='typegest-label'
                            aria-required='true'
                            a11yTitle='Tipo gestore'
                            dropAlign={{ top: 'bottom' }}
                            dropProps={{
                                a11yTitle: 'Opzioni di tipo gestore disponibili',
                                role: 'listbox',
                                'aria-multiselectable': 'false'
                            }}
                        />
                    </Box>
                    {this.props.values.selectedType === 'Società' ?
                        <Box id='searchpv' style={{ marginBottom: '29px' }}>
                            <Text className='label'>CODICE SOCIETÀ</Text>
                            <TextInput id='codesoc' className='inputGest disabled' value={this.props.values.codsocieta} disabled />
                        </Box> : this.props.values.selectedType === 'Punto Vendita' ?
                            <Box id='searchpv' style={{ marginBottom: '29px' }}>
                                <Text className='label' id='pv-code-label' htmlFor='pv-code' aria-hidden="false">CODICE PUNTO VENDITA</Text>
                                <AccessibleSelect 
                                    id='pv-code' 
                                    className='select' 
                                    placeholder='' 
                                    options={this.state.optionPV} 
                                    value={this.props.values.selectedPV} 
                                    onChange={this.props.setSelectionPv}
                                    aria-labelledby='pv-code-label'
                                    aria-required='true'
                                    a11yTitle='Codice punto vendita'
                                    dropAlign={{ top: 'bottom' }}
                                    dropProps={{
                                        a11yTitle: 'Opzioni di codice punto vendita disponibili',
                                        role: 'listbox',
                                        'aria-multiselectable': 'false'
                                    }}
                                />
                            </Box>
                            : null}
                    <Box>
                        <Box style={{ width: '200px' }}>
                            <Text className='label'>EMAIL</Text>
                            <TextInput id='emailGestore' maxLength={50} className={this.props.values.selectedType !== '' ? 'inputGest' : 'inputGest disabled'} disabled={this.props.values.selectedType !== '' ? false : true} defaultValue={this.props.values.emailGestore} /*emailGestore={this.props.values.emailGestore}*/ onChange={this.props.emailGestore} />
                            {this.props.values.msgemailGestore ? <Text className='error'>{ERRORMESSAGE.msgemail}</Text> : <Text className='errorhide'></Text>}
                        </Box>
                    </Box>
                    <Box id='searchpv'>
                        <Text className='label' id='listuser-label' htmlFor='listuser' aria-hidden="false">LISTA UTENTI</Text>
                        <AccessibleSelect 
                            id='listuser' 
                            className='select' 
                            disabled={this.props.values.selectedType !== '' ? false : true} 
                            options={this.props.values.selectedType === "Punto Vendita" && this.props.values.codes.length === 0 ? [] : this.readListUsername()} 
                            value={this.props.values.selectedUser} 
                            onChange={this.props.setSelectionUser}
                            aria-labelledby='listuser-label'
                            aria-required='true'
                            a11yTitle='Lista utenti'
                            dropAlign={{ top: 'bottom' }}
                            dropProps={{
                                a11yTitle: 'Opzioni di utenti disponibili'
                            }}
                        />
                    </Box>
                </Box>
            </Box>
            <Box style={{ padding: '30px 20px 0 20px' }}>
                <Text className='subtitlehome' style={{ marginBottom: '20px' }}>{DISPUTE.infoParagraph8} <Anchor onClick={this.redirectRegistration}>clicca qui</Anchor></Text>
                <Text justify='left' className='subtitlehome'>Gli avvisi via e-mail saranno <span className='bold'>inviati automaticamente</span> al GESTORE. Se il GESTORE e il RESPONSABILE coincidono,
                                                                verrà inviata una mail unica. <Anchor onClick={this.props.showModalemailGestore}>Clicca qui</Anchor> per visualizzare i criteri di invio.</Text>
                {this.props.values.openModalemail === true ? sendEmail : ''}<br />
                <Box direction='row' style={{ marginBottom: '25px' }}>
                    <Text className='subtitlehome'>{DISPUTE.infoParagraph9}</Text>
                </Box>
                <Box justify='center' direction='row'>
                    <Button className='btnform' style={{ width: '170px', margin: '0 30px 30px 0' }} onClick={this.back}>Indietro</Button>
                    <Button id='gestore' className='btnform' disabled={this.props.values.selectedType !== '' ? enabled : true} style={{ width: '170px', marginBottom: '30px' }} onClick={this.saveAndContinue} aria-label="Prosegui al passo successivo per riepilogo dati">Prosegui</Button>
                </Box>
            </Box>
        </Box>)

        const Gestori = (<Box>
            {this.state.showTimeoutModal || this.props.values.showTimeoutModal ? <ModalErrorTimeout /> : ''}
            <Box style={{ padding: '30px 50px 0 50px' }}>
                <Text className='titleDispute'><h3>DEFINISCI GESTORI</h3></Text>

                <Box align='center'>
                    {this.props.values.errorMails ? <Text className='error' style={{ fontFamily: 'Segoe UI Semibold', fontSize: '14px', marginBottom: '10px' }}>Email non valida</Text> :
                        <Text style={{ marginBottom: '34px' }}></Text>}
                    <ReactTable
                        data={this.state.data}
                        columns={tableGestori}
                        sortable={true}
                        multiSort={true}
                        resizable={true}
                        showPagination={false}
                        loading={false}
                        defaultPageSize={10}
                        style={{ paddingBottom: '20px', width: '100%' }}
                    />
                    <div>
                        <div style={{ height: '50px', display: 'flex-wrap', flexDirection: 'row' }}>
                            <button
                                type="button"
                                style={{ width: '20px', height: '30px', background: 'none', border: 'none', padding: 0, color: this.state.currentPage === 1 ? '#999' : '#006fcf', cursor: this.state.currentPage === 1 ? 'not-allowed' : 'pointer', display: 'inline-flex', alignItems: 'center' }}
                                onClick={(e) => { e.preventDefault(); this.prevPage(); }}
                                onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); this.prevPage(); } }}
                                disabled={this.state.currentPage === 1}
                                tabIndex={this.state.currentPage === 1 ? "-1" : "0"}
                                aria-label="Pagina precedente"
                            >
                                <i className='icon-left-chevron' style={{ fontSize: '12px', fontStyle: 'normal' }} aria-hidden="true"></i>
                            </button>

                            <Text className='pag' style={{ fontSize: '12px', marginBottom: '12px' }}>{this.state.currentPage} di {this.state.pages}</Text>

                            <button
                                type="button"
                                style={{ width: '20px', background: 'none', border: 'none', padding: 0, color: this.state.currentPage === this.state.pages ? '#999' : '#006fcf', cursor: this.state.currentPage === this.state.pages ? 'not-allowed' : 'pointer', display: 'inline-flex', alignItems: 'center' }}
                                onClick={(e) => { e.preventDefault(); this.nextPage(); }}
                                onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); this.nextPage(); } }}
                                disabled={this.state.currentPage === this.state.pages}
                                tabIndex={this.state.currentPage === this.state.pages ? "-1" : "0"}
                                aria-label="Pagina successiva"
                            >
                                <i className='icon-right-chevron' style={{ fontSize: '12px', fontStyle: 'normal' }} aria-hidden="true"></i>
                            </button>
                        </div>
                    </div>
                </Box>
            </Box>
            <Box style={{ padding: '30px 20px 0 20px' }}>
                {/* <Text className='subtitlehome error' style={{ marginBottom: '20px' }}>{DISPUTE.infoParagraph12}</Text> */}
                <Box justify='center' direction='row'>
                    <Button className='btnform' style={{ width: '170px', margin: '0 30px 30px 0' }} onClick={() => { this.props.showGestore(); this.resetPage(); }}>Indietro</Button>
                    <Button id='gestori' className='btnform' style={{ width: '170px', marginBottom: '30px' }} disabled={this.state.disableBtn} onClick={(e) => this.saveAndContinue(e, 'gestori')} aria-label="Prosegui al passo successivo per riepilogo dati">Prosegui</Button>
                </Box>
            </Box>
        </Box>)

        return (
            <Box>
                {this.props.values.showGestore ? Gestore : this.props.values.showGestori ? Gestori : null}
            </Box>
        )
    }
}

export default withRouter(DatiGestore);
